import vue from 'vue';

export default function buildSequenceCheckStore(store){
    store.actions.doCheckDone = async (context, params) => await vue.prototype.$myHttp.post('/api/sequenceChecks/doCheckDone', params);
    return store;
}